import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './listing-page.css'

const ListingPage = (props) => {
  return (
    <div className="listing-page-container1">
      <Helmet>
        <title>Listing-Page - Dogeet</title>
        <meta
          property="og:title"
          content="Listing-Page - Dogeet"
        />
        <link
          rel="canonical"
          href="https://dogeet.com/listing-page"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="listing-page-container2">
        <div className="listing-page-container3">
          <Script
            html={`<style>
input:checked + .slider {
  background-color: var(--color-primary);
}
input:checked + .slider:before {
  transform: translateX(26px);
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="listing-hero">
        <div className="hero-media-wrapper">
          <img
            src="https://images.pexels.com/photos/3907507/pexels-photo-3907507.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Vintage Nikon Camera"
            className="hero-bg-image"
          />
          <div className="listing-page-hero-overlay"></div>
        </div>
        <div className="hero-content-container">
          <div className="hero-text-block">
            <div className="hero-meta-row">
              <span className="listing-page-hero-badge">Local Pickup Only</span>
              <span className="hero-post-age">Posted 2 hours ago</span>
            </div>
            <h1 className="hero-title">
              Vintage Nikon FM2 - Collector&apos;s Condition
            </h1>
            <div className="hero-price-stack">
              <div className="hero-doge-price">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 8l-4 4 4 4"></path>
                  <path d="M16 12H8"></path>
                </svg>
                <span>4,200 DOGE</span>
              </div>
              <span className="hero-usd-ref">≈ $630.00 USD</span>
            </div>
            <div className="hero-tag-cloud">
              <span className="tag-chip">Vintage</span>
              <span className="tag-chip">Near Mint</span>
              <span className="tag-chip">Tested</span>
            </div>
            <div className="hero-actions">
              <button className="btn btn-primary btn-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                <span>
                  {' '}
                  Message Seller
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="btn btn-lg btn-outline">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                </svg>
                <span>
                  {' '}
                  Favorite
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
              <button className="btn btn-link btn-sm">Report Listing</button>
            </div>
          </div>
        </div>
      </section>
      <section className="gallery-parallax">
        <div className="gallery-carousel-container">
          <div id="galleryTrack" className="gallery-track">
            <div className="gallery-item active">
              <img
                src="https://images.pexels.com/photos/3907507/pexels-photo-3907507.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Nikon FM2 Front View"
              />
              <div className="gallery-caption">
                <span>Front view showcasing the pristine lens and body.</span>
              </div>
            </div>
            <div className="gallery-item">
              <img
                src="https://images.pexels.com/photos/18719708/pexels-photo-18719708.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Lens Detail"
              />
              <div className="gallery-caption">
                <span>Detailed view of the 50mm f/1.8 Nikkor lens.</span>
              </div>
            </div>
            <div className="gallery-item">
              <img
                src="https://images.pexels.com/photos/11911070/pexels-photo-11911070.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Back Plate"
              />
              <div className="gallery-caption">
                <span>Rear view showing no wear on the pressure plate.</span>
              </div>
            </div>
          </div>
          <div className="gallery-controls">
            <button id="prevBtn" className="gallery-nav prev">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m15 18-6-6 6-6"></path>
              </svg>
            </button>
            <button id="nextBtn" className="gallery-nav next">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </button>
          </div>
          <div className="gallery-authenticity">
            <div className="auth-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
              </svg>
              <span>
                {' '}
                Verified Authentic
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-details">
        <div className="pricing-container">
          <div className="pricing-header">
            <h2 className="section-title">Listing Specifications</h2>
            <div className="currency-toggle">
              <span>Show USD</span>
              <label className="switch">
                <input type="checkbox" id="usdToggle" />
                <span className="listing-page-thq-slider-elm round"></span>
              </label>
            </div>
          </div>
          <div className="pricing-table-wrapper">
            <table className="pricing-table">
              <tbody>
                <tr>
                  <td className="label">
                    <span>DOGE Amount</span>
                  </td>
                  <td className="value highlight">
                    <span>4,200.00 Ð</span>
                  </td>
                </tr>
                <tr className="listing-page-thq-usd-row-elm usd-row">
                  <td className="label">
                    <span>USD Reference</span>
                  </td>
                  <td className="value">
                    <span>$630.00</span>
                  </td>
                </tr>
                <tr>
                  <td className="label">
                    <span>Pricing Type</span>
                  </td>
                  <td className="value">
                    <span className="status-tag">Negotiable</span>
                  </td>
                </tr>
                <tr>
                  <td className="label">
                    <span>Category</span>
                  </td>
                  <td className="value">
                    <span>Photography &gt; Film Cameras</span>
                  </td>
                </tr>
                <tr>
                  <td className="label">
                    <span>Model</span>
                  </td>
                  <td className="value">
                    <span>Nikon FM2 (Silver)</span>
                  </td>
                </tr>
                <tr>
                  <td className="label">
                    <span>Condition</span>
                  </td>
                  <td className="value">
                    <span>Near Mint (9.5/10)</span>
                  </td>
                </tr>
                <tr>
                  <td className="label">
                    <span>Payments</span>
                  </td>
                  <td className="value">
                    <span>DOGE only. P2P non-custodial.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="contact-seller">
        <div className="contact-card-container">
          <div className="contact-card">
            <div className="contact-info">
              <h2 className="section-title">Interested?</h2>
              <p className="section-content">
                Send a secure message through Dogeet&apos;s masked relay.
              </p>
              <div className="seller-stats-grid">
                <div className="stat-item">
                  <span className="listing-page-stat-label">Response Time</span>
                  <span className="listing-page-stat-value">~ 2 hours</span>
                </div>
                <div className="stat-item">
                  <span className="listing-page-stat-label">Seller Rating</span>
                  <div className="rating-stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                    </svg>
                    <span>4.9 (12 reviews)</span>
                  </div>
                </div>
              </div>
            </div>
            <form
              action="/submit"
              method="POST"
              data-form-id="a06af00d-5497-4dbe-9db5-bbe4a701316d"
              className="contact-form"
            >
              <div className="input-group">
                <textarea
                  name="message"
                  placeholder="Hi! Is this still available? I can meet in Downtown tomorrow..."
                  required="true"
                  minlength="10"
                  id="thq_message_lwgU"
                  data-form-field-id="thq_message_lwgU"
                  className="form-control"
                ></textarea>
              </div>
              <button
                type="submit"
                id="thq_button_VEFQ"
                name="button"
                data-form-field-id="thq_button_VEFQ"
                className="btn btn-accent btn-xl"
              >
                Send Secure Message
              </button>
              <p className="safety-disclaimer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
                </svg>
                <span>
                  {' '}
                  Dogeet never holds your DOGE. Use a trusted wallet for P2P
                  transfers.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </form>
          </div>
        </div>
      </section>
      <section className="seller-showcase">
        <div className="showcase-container">
          <div className="seller-profile-card">
            <div className="profile-main">
              <div className="avatar-wrapper">
                <img
                  src="https://images.pexels.com/photos/13009437/pexels-photo-13009437.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Seller Avatar"
                  className="profile-avatar"
                />
                <span className="online-indicator"></span>
              </div>
              <div className="profile-info">
                <h3 className="profile-name">
                  <span>
                    ShibeCollector99
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="listing-page-thq-badge-power-elm">
                    Power Seller
                  </span>
                </h3>
                <p className="profile-meta">
                  Member since April 2021 • 5.2km away
                </p>
                <div className="profile-actions">
                  <a href="#">
                    <div className="btn btn-outline btn-sm">
                      <span>View 14 other listings</span>
                    </div>
                  </a>
                  <button className="btn btn-link btn-sm">Follow Seller</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="listing-features">
        <div className="features-container">
          <div id="featuresTabs" className="tabs-header">
            <button data-tab="description" className="tab-trigger active">
              Description
            </button>
            <button data-tab="specs" className="tab-trigger">
              Technical Specs
            </button>
            <button data-tab="readiness" className="tab-trigger">
              Buyer Readiness
            </button>
          </div>
          <div className="tabs-content">
            <div id="description" className="tab-panel active">
              <p className="section-content">
                This Nikon FM2 is a true gem for any film enthusiast. Kept in a
                dry cabinet for years, the shutter speeds are all accurate, and
                the light meter works perfectly. It comes with the legendary
                50mm f/1.8 lens which is clean of any fungus or haze.
              </p>
              <p className="section-content">
                I&apos;m selling because I&apos;m upgrading to a medium format
                system. This camera has been my reliable companion for street
                photography and never missed a beat. Such wow, much quality!
              </p>
            </div>
            <div id="specs" className="tab-panel">
              <div className="specs-grid">
                <div className="spec-item">
                  <strong>Shutter Type:</strong>
                  <span> Vertical-travel metal focal-plane</span>
                </div>
                <div className="spec-item">
                  <strong>Speeds:</strong>
                  <span> 1s to 1/4000s + Bulb</span>
                </div>
                <div className="spec-item">
                  <strong>Mount:</strong>
                  <span> Nikon F-Mount</span>
                </div>
                <div className="spec-item">
                  <strong>Weight:</strong>
                  <span> 540g (Body only)</span>
                </div>
              </div>
            </div>
            <div id="readiness" className="tab-panel">
              <div className="readiness-checklist">
                <div className="check-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 6 9 17l-5-5"></path>
                  </svg>
                  <span>Fully Tested &amp; Functional</span>
                </div>
                <div className="check-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M20 6 9 17l-5-5"></path>
                  </svg>
                  <span>Local Meetup Available</span>
                </div>
                <div className="check-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                  </svg>
                  <span className="muted">Shipping Not Available</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="explore-local">
        <div className="listing-page-explore-header">
          <h2 className="section-title">More Nearby Finds</h2>
          <p className="section-subtitle">Local listings priced in DOGE</p>
        </div>
        <div className="horizontal-scroller">
          <div className="scroll-item">
            <div className="item-card">
              <img
                src="https://images.pexels.com/photos/2263822/pexels-photo-2263822.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Game Boy Color"
              />
              <div className="item-details">
                <span className="item-price">1,200 Ð</span>
                <span className="item-dist">1.2km</span>
                <p className="item-name">Game Boy Color - Red</p>
              </div>
            </div>
          </div>
          <div className="scroll-item">
            <div className="item-card">
              <img
                src="https://images.pexels.com/photos/1637437/pexels-photo-1637437.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Retro NES"
              />
              <div className="item-details">
                <span className="item-price">3,500 Ð</span>
                <span className="item-dist">3.8km</span>
                <p className="item-name">Classic NES + 2 Controllers</p>
              </div>
            </div>
          </div>
          <div className="scroll-item">
            <div className="item-card">
              <img
                src="https://images.pexels.com/photos/10401663/pexels-photo-10401663.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Vintage Suitcases"
              />
              <div className="item-details">
                <span className="item-price">800 Ð</span>
                <span className="item-dist">0.5km</span>
                <p className="item-name">Set of 3 Vintage Suitcases</p>
              </div>
            </div>
          </div>
          <div className="scroll-item">
            <div className="item-card">
              <img
                src="https://images.pexels.com/photos/7206225/pexels-photo-7206225.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Medium Format Camera"
              />
              <div className="item-details">
                <span className="item-price">12,000 Ð</span>
                <span className="item-dist">7.2km</span>
                <p className="item-name">Hasselblad 500C/M Kit</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="safety-cta">
        <div className="alert-banner">
          <div className="alert-content">
            <div className="alert-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                <path d="M12 9v4"></path>
                <path d="M12 17h.01"></path>
              </svg>
            </div>
            <div className="alert-text">
              <h2 className="section-title">Trade Safely, Shibe!</h2>
              <p className="section-content">
                Always meet in public places for local trades. Dogeet is
                peer-to-peer; we will never ask for your private keys. If it
                sounds too good to be true, it probably is.
              </p>
              <div className="alert-actions">
                <a href="#">
                  <div className="btn btn-secondary">
                    <span>Safety Guide</span>
                  </div>
                </a>
                <button className="btn btn-outline btn-sm">
                  Report Suspicious Activity
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="listing-page-container4">
        <div className="listing-page-container5">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(10px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="listing-page-container6">
        <div className="listing-page-container7">
          <Script
            html={`<script defer data-name="dogeet-listing-logic">
(function(){
  // Gallery Logic
  const track = document.getElementById('galleryTrack');
  const items = document.querySelectorAll('.gallery-item');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  let currentIndex = 0;

  function updateGallery() {
    track.style.transform = \`translateX(-\${currentIndex * 100}%)\`;
    items.forEach((item, index) => {
      item.classList.toggle('active', index === currentIndex);
    });
  }

  nextBtn.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % items.length;
    updateGallery();
  });

  prevBtn.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    updateGallery();
  });

  // USD Toggle Logic
  const usdToggle = document.getElementById('usdToggle');
  const usdRows = document.querySelectorAll('.usd-row');

  usdToggle.addEventListener('change', () => {
    usdRows.forEach(row => {
      row.style.display = usdToggle.checked ? 'table-row' : 'none';
    });
  });

  // Tabs Logic
  const tabTriggers = document.querySelectorAll('.tab-trigger');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const target = trigger.getAttribute('data-tab');
      
      tabTriggers.forEach(t => t.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      
      trigger.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });

  // Parallax Effect for Hero
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const heroMedia = document.querySelector('.hero-bg-image');
    if (heroMedia) {
      heroMedia.style.transform = \`translateY(\${scrolled * 0.3}px)\`;
    }
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ListingPage
